import React, {useState, useCallback, useContext} from 'react';

import Link from '~/src/components/link/Link';
import Boomerang from '~/src/components/svg/general/Boomerang';

import {CommentSortColumn} from '~/src/utilities/constants/api';
import {getPageUrl} from '~/src/utilities/helpers/link';
import {classNames} from '~/src/utilities/helpers/css';
import initPolyglot from '~/src/utilities/libs/polyglot';
import {SettingsContext} from '~/src/components/context/SettingsContext';

import css from './CommentSort.module.scss';
import i18n from './CommentSort.i18n.json';

const translate = initPolyglot(i18n);

const CommentSort = ({id, sortBy}) => {
    const {siteArea} = useContext(SettingsContext);
    const [showAll, setShowAll] = useState(false);

    const toggleAll = useCallback(() => setShowAll(!showAll), [showAll]);

    const className = classNames(css, 'sort', siteArea, {showAll});

    const sortByTitle = sortBy.startsWith(CommentSortColumn.REACTIONS) ? CommentSortColumn.REACTIONS : sortBy;

    return (
        <div className={className} onClick={toggleAll}>
            <button className={css.label} title={translate('sort')}>
                {translate(sortByTitle)}
                <Boomerang />
            </button>
            <div className={css.list}>
                <Link className={classNames(css, 'link', {active: sortBy === CommentSortColumn.CREATED_AT})} href={getPageUrl(`/comment/${id}`)}>
                    {translate(CommentSortColumn.CREATED_AT)}
                </Link>
                <Link
                    className={classNames(css, 'link', {active: sortBy.startsWith(CommentSortColumn.REACTIONS)})}
                    href={getPageUrl(`/comment/${id}/${CommentSortColumn.REACTIONS}`)}
                >
                    {translate(CommentSortColumn.REACTIONS)}
                </Link>
                <Link
                    className={classNames(css, 'link', {active: sortBy === CommentSortColumn.REPLIES})}
                    href={getPageUrl(`/comment/${id}/${CommentSortColumn.REPLIES}`)}
                >
                    {translate(CommentSortColumn.REPLIES)}
                </Link>
            </div>
        </div>
    );
};

export default CommentSort;
